import { isServer } from "@/src/lib/runtime";

export async function getRequestContext(): Promise<{
  tid?: string;
  path?: string;
  warmup?: boolean;
  params: {
    cloudTasksTaskName?: string;
    taskId?: string;
    patientId?: string;
  };
}> {
  if (!isServer) {
    return { params: {} };
  }

  try {
    const { headers } = await import("next/headers");
    const { isWarmupRequest, WARMUP_REQUEST_HEADER } = await import("@/src/lib/warmup-request");
    const headersList = await headers();
    const tid = headersList.get("x-trace-id");
    const path = headersList.get("x-path");
    const cloudTaskName = headersList.get("x-cloudtasks-taskname");
    const taskId = headersList.get("x-task-id");
    const patientId = headersList.get("x-patient-id");

    // This process's own loopback startup warmup traffic.
    const warmup = isWarmupRequest(path ?? "", headersList.get(WARMUP_REQUEST_HEADER));

    return {
      ...(tid && { tid }),
      ...(path && { path }),
      ...(warmup && { warmup }),
      params: {
        ...(cloudTaskName && { cloudTaskName }),
        ...(taskId && { taskId }),
        ...(patientId && { patientId }),
      },
    };
  } catch {
    return { params: {} };
  }
}
